import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

interface ErrorModalProps {
  open: boolean;
  children: JSX.Element;
  onClose: () => void;
}

const ErrorModal = ({ open, children, onClose }: ErrorModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal open={open} onCancel={onClose} footer={null}>
      {children}
      {/* <ButtonCancel onClick={onClose}>{t("button-cancel")!}</ButtonCancel> */}
    </Modal>
  );
};
export default ErrorModal;

interface IDisplayErrorProps {
  error: string | FetchBaseQueryError | SerializedError;
}

export const DisplayError = ({ error }: IDisplayErrorProps) => {
  if (typeof error === "string") {
    return <>{error}</>;
  } else if (isFetchBaseQueryError(error)) {
    if (error.status === "FETCH_ERROR") {
      return <>{error["error"]}</>;
    } else if (["400", "401", "404", "500"].includes(error.status?.toString() ?? "")) {
      if (Array.isArray(error.data)) {
        return error.data.length === 1 ? (
          <>{error.data[0]}</>
        ) : (
          <ul>
            {error.data.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        );
      } else if (typeof error.data === "string") {
        return <>{error.data}</>;
      } else if (error.data && typeof error.data === "object") {
        const data = error.data as ProblemDetails;

        return (
          <>
          {data.detail}
            {/* <span>{data.title}</span>
            <ul>
              {Array.isArray(data.errors) ? (
                data.errors.map((msg, index) => <li key={index}>{msg}</li>)
              ) : (
                <li>Errore sconosciuto</li>
              )}
            </ul> */}
          </>
        );
      }
    }
    return <>Si è verificato un errore!</>;
  } else {
    return <>Si è verificato un errore!</>;
  }
};

const isFetchBaseQueryError = (error: any): error is FetchBaseQueryError =>
  !!(error && typeof error === "object" && "status" in error);

type ProblemDetails = {
  title: string;
  // errors: string[];
  detail?: string;
};

// status	400
// type	"CustomException"
// title	"Cannot process request"
// detail	"subject-role 544-P combination already exist for the practice id=120 selected"
// instance	null
// invalidParams	[]